type AppName = "OnSchedule" | "CraneIQ" | "RepairIQ";

const localApps = [
  { name: "OnSchedule", logo: "/app-family/onschedule.png", url: "http://127.0.0.1:5177/dashboard", accent: "#729c5b" },
  { name: "CraneIQ", logo: "/app-family/craneiq.png", url: "http://127.0.0.1:3002/", accent: "#c91030" },
  { name: "RepairIQ", logo: "/app-family/repairiq.png", url: "http://127.0.0.1:3202/", accent: "#14549a" },
] as const;
const pilotApps = [
  { name: "OnSchedule", logo: "/app-family/onschedule.png", url: "https://pilot.onschedule.ca/dashboard", accent: "#729c5b" },
  { name: "CraneIQ", logo: "/app-family/craneiq.png", url: "https://pilot.onschedule.ca/dashboard/open-app/craneiq", accent: "#c91030" },
  { name: "RepairIQ", logo: "/app-family/repairiq.png", url: "https://pilot.onschedule.ca/dashboard/open-app/repairiq", accent: "#14549a" },
] as const;

/** Exact known deployments only; arbitrary hostnames never choose a destination. */
export function familyAppsForHost(hostname: string) {
  if (["127.0.0.1", "localhost"].includes(hostname)) return localApps;
  if (["craneiq-pilot.onschedule.ca", "repairiq-pilot.onschedule.ca"].includes(hostname)) return pilotApps;
  const origin = ["craneiq-release-staging.onschedule.ca", "repairiq-release-staging.onschedule.ca"].includes(hostname)
    ? "https://release-staging.onschedule.ca"
    : ["craneiq.onschedule.ca", "repairiq.onschedule.ca"].includes(hostname)
      ? "https://onschedule.ca" : null;
  if (!origin) return null;
  return pilotApps.map(app => ({ ...app, url: app.url.replace("https://pilot.onschedule.ca", origin) }));
}

/** Show exact local or isolated pilot destinations. */
export function mountAppFamilyLauncher(
  current: AppName,
  after: Element,
  beforeNavigate?: () => Promise<boolean> | boolean,
) {
  const hostname = window.location.hostname;
  const apps = familyAppsForHost(hostname);
  if (!apps) return;
  const local = ["127.0.0.1", "localhost"].includes(hostname);
  const pilot = !local; // legacy variable name; shared protected deployments use the same launcher.

  const launcher = document.createElement("details");
  launcher.className = "family-launcher";
  launcher.innerHTML = `<summary aria-label="Open applications"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg><span>Apps</span></summary><div class="family-panel" aria-label="Applications"><div class="family-heading"><strong>Applications</strong><small>Your workspace tools</small></div><div class="family-grid">${apps.map((app) => {
    const selected = app.name === current;
    const inner = `<span class="family-logo"><img src="${app.logo}" alt=""></span><strong>${app.name}</strong><small>${selected ? "Current app" : pilot ? "Open app" : "Open local demo"}</small>`;
    return selected
      ? `<div class="family-card is-current" style="--family-accent:${app.accent}" aria-current="page">${inner}</div>`
      : `<a class="family-card" style="--family-accent:${app.accent}" href="${app.url}" aria-label="Open ${app.name} ${local ? "local demo" : "app"}">${inner}</a>`;
  }).join("")}</div></div>`;
  after.insertAdjacentElement("afterend", launcher);

  launcher.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      launcher.open = false;
      (launcher.querySelector("summary") as HTMLElement).focus();
    }
  });
  if (beforeNavigate) {
    launcher.querySelectorAll<HTMLAnchorElement>("a.family-card").forEach((link) => {
      link.addEventListener("click", async (event) => {
        event.preventDefault();
        if (await beforeNavigate()) window.location.assign(link.href);
      });
    });
  }
}
